exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#user-settings .option > .bootstrap-switch {\n  right: 0;\n  position: absolute;\n  top: 5px;\n}\n", ""]);

// exports
